import { Platform } from "quasar";
import MaRefs from "src/modules/ma/classes/ma_refs";

export default {
  services: {
    value: {
      cf: {
        url: undefined,
        jwt: undefined,
      },
      sqlr: {
        url: undefined,
        jwt: undefined,
      },
      sqlr_dataset: {
        url: undefined,
        jwt: undefined,
      },
      tdl: {
        url: undefined,
        jwt: undefined,
      },
      toexcel: {
        url: undefined,
        jwt: undefined,
      },
      cube: {
        url: undefined,
        jwt: undefined,
      },
      minio: {
        url: undefined,
        jwt: undefined,
      },
      cube2csv: {
        url: undefined,
        jwt: undefined,
      },
      idom: {
        users: undefined,
        channels: undefined,
        settings: undefined,
        relations: undefined,
        policies: undefined,
      },
    },
  },
  alternativeBackends: {
    name: "Резервные backend'ы",
    type: "string",
    value: "",
    defaultValue: "",
    devMode: true,
    access: "ma_access:5c173556783bba005b8976fa",
  },
  alternativeBackendsTimeout: {
    name: "Timeout для использования резервных backend'ов",
    type: "int",
    value: 2000,
    defaultValue: 2000,
    devMode: true,
    access: "ma_access:5c173556783bba005b8976fa",
  },
  aLogsEnabled: {
    type: "bool",
    value: false,
    defaultValue: false,
  },
  devMode: {
    name: "Средства разработчика",
    type: "bool",
    value: false,
    defaultValue: false,
    access: "ma_access:5c173556783bba005b8976fa",
  },
  recognitionProfile: {
    value: null,
    defaultValue: null,
  },
  recognitionProfileRef: {
    name: "Профиль распознавания звука",
    type: "ref",
    value: null,
    defaultValue: null,
    devMode: true,
    clearable: false,
    field: {
      key: "recognitionProfileRef",
      type_of_link: MaRefs.ref.types.sttV2Profile,
      _client_sort_desc: true,
    },
    group: "rec_audio",
  },
  recAgainProfileRefs: {
    name: "Профили повторного распознавания звука",
    type: "ref",
    value: [],
    defaultValue: [],
    devMode: true,
    clearable: true,
    field: {
      key: "recAgainProfileRefs",
      type_of_link: MaRefs.ref.types.sttV2Profile,
      is_list: true,
      _client_sort_desc: true,
    },
    group: "rec_audio",
  },
  generationProfileRef: {
    name: "Профиль генерации звука",
    type: "ref",
    value: null,
    defaultValue: null,
    devMode: true,
    clearable: false,
    field: {
      key: "generationProfileRef",
      type_of_link: MaRefs.ref.types.ttsV2Profile,
      _client_sort_desc: true,
    },
    group: "gen_audio",
  },
  app_ref: {
    name: "App",
    type: "ref",
    value: null,
    defaultValue: null,
    devMode: true,
    clearable: true,
    field: {
      key: "app_ref",
      type_of_link: MaRefs.ref.types.app,
      _client_sort_asc: true,
    },
    group: "meta",
  },
  base_app: {
    name: "Base App",
    type: "string",
    value: null,
    defaultValue: null,
    devMode: true,
    access: "ma_access:5fc0c7096a199300107e94aa",
  },
  wfRef: {
    name: "Workflow",
    type: "ref",
    value: null,
    defaultValue: null,
    devMode: true,
    clearable: true,
    authMode: true,
    field: {
      key: "wfRef",
      type_of_link: MaRefs.ref.types.workflow,
      backlist: MaRefs.ref.objs.pointsOfEntry,
    },
    group: "meta",
  },
  chatSenderType: {
    name: "Способ отправки сообщений в чате",
    type: "select",
    options: ["proceedQuestion", "run_ds", "run_ds_safe"],
    value: "proceedQuestion",
    defaultValue: "proceedQuestion",
    group: "meta",
    devMode: true,
    access: "ma_access:5c173556783bba005b8976fa",
  },
  clientSource: {
    name: "Тип клиента",
    type: "select",
    options: ["web", "sip"],
    value: "web",
    defaultValue: "web",
    group: "chat",
    devMode: true,
    access: "ma_access:5c173556783bba005b8976fa",
  },
  clientSourcePhone: {
    name: 'Номер телефона (используется для эмуляции "тип клиента = sip")',
    type: "text",
    value: "88005553535",
    defaultValue: "88005553535",
    group: "chat",
    devMode: true,
    access: "ma_access:5c173556783bba005b8976fa",
  },
  backend: {
    name: "Backend",
    type: "select",
    options: [],
    value: "",
    defaultValue: "",
    group: "meta",
    devMode: true,
  },
  datasetWfRef: {
    value: "cc_wf:5efedf459671d70011cdfee3",
    defaultValue: "cc_wf:5efedf459671d70011cdfee3",
  },
  menuItems: {
    value: [
      {
        link: "#/",
        text: "Главная",
      },
    ],
    defaultValue: [
      {
        link: "#/",
        text: "Главная",
      },
    ],
  },
  __pageMap: {
    value: {},
    defaultValue: {},
  },
  freeRecInterimResults: {
    value: !Platform.is.mobile,
    defaultValue: !Platform.is.mobile,
  },
  settingsGroups: {
    value: [
      { key: "meta", name: "Приложение", opened: true },
      { key: "chat", name: "Чат (функциональность)" },
      { key: "visual", name: "Чат (отображение)" },
      { key: "rec_audio", name: "Распознавание звука" },
      { key: "gen_audio", name: "Генерация звука" },
      { key: "phone", name: "Телефония" },
      { key: "auto_open", name: "Автоматическое открытие" },
      { key: "settings", name: "Настройки настроек" },
      { key: "other", name: "Другое" },
      {
        key: "compessor_params",
        name: "Параметры compessor-а",
        hidden: true,
      },
      { key: "biquad_params", name: "Параметры biquad-а", hidden: true },
    ],
  },
};
